import { useCallback } from "react";
import { useSearchParams } from "react-router";

import { useSearchParamWriter } from "@/hooks/use-search-param-writer";

/** URL param that holds the takeover open (survives reload/share, POS2-878). */
const PARAM = "display";
const VALUE = "kitchen";

/**
 * Kitchen Display overlay state, backed by `?display=kitchen` so it survives a
 * reload and Back closes it. `open()` requests the Fullscreen API from inside
 * the click gesture (a post-render effect would be rejected by the browser);
 * `close()` leaves fullscreen and drops the param. Both are best-effort on
 * fullscreen — an unsupported/denied request still opens the overlay.
 */
export function useKitchenDisplay() {
  const [searchParams] = useSearchParams();
  const isOpen = searchParams.get(PARAM) === VALUE;
  // Pushes rather than replaces — Back closing the overlay is the point.
  const { write } = useSearchParamWriter({ replace: false });

  const open = useCallback(() => {
    void document.documentElement.requestFullscreen?.().catch(() => {});
    write((next) => next.set(PARAM, VALUE));
  }, [write]);

  const close = useCallback(() => {
    if (document.fullscreenElement) void document.exitFullscreen?.().catch(() => {});
    write((next) => next.delete(PARAM));
  }, [write]);

  return { isOpen, open, close };
}
